import { FirestoreDataConverter, Timestamp } from 'firebase/firestore';
import { Entity } from './entity';

export interface UserReading extends Entity {
  completedAt: Date;
}

export interface FirestoreUserReading extends Omit<UserReading, 'completedAt'> {
  completedAt: Timestamp;
}

export const UserReadingConverter: FirestoreDataConverter<UserReading, FirestoreUserReading> = {
  toFirestore: (reading: UserReading): FirestoreUserReading => {
    return {
      ...reading,
      completedAt: Timestamp.fromDate(reading.completedAt),
    };
  },
  fromFirestore: (snapshot, options): UserReading => {
    const reading = snapshot.data(options) as FirestoreUserReading;
    return {
      ...reading,
      completedAt: reading.completedAt.toDate(),
    };
  },
};

export const UserReadingCollection = 'readings';
